import React from 'react';
import { Box, keyframes, Text } from '@chakra-ui/react';



const CenteredBox = () => {
  return (
    <Box
      px={{ base: '1', md: '5' }}
      py="10"
      display="flex"
      justifyContent="center"
      alignItems="center"
      w="100%"
      h="20vh"
      marginTop={{ base: '0em', md: '1em' }}
    >
      <Box
        bg="white"
        p={{ base: '2', md: '8' }}
        borderRadius="xl"
        w={{ base: '95%', md: '80%' }}
        textAlign="center"
        boxShadow="lg"
        overflow="hidden"  // Oculta el texto que sale del box
        position="relative"
      >
        <Text
          fontSize="2xl"
          color="red"
          fontFamily="'Fugaz One', sans-serif"  // Fuente del Hero de Seiya
          textTransform="uppercase"  // Texto en mayúsculas
          fontWeight="bold"
          style={{textShadow:'1px 1px 1px black'}}>
          FAIR LAUNCHED AT <a href="#" target='_blank' style={{textDecoration:'underline'}}>SEIYAN.FUN</a>
        </Text>
        <Text textAlign="center" fontSize="sm" color="black" marginTop="1em">
          CA: 0x0000000000000000000000000000000000000000
        </Text>
      </Box>
    </Box>
  );
};

export default CenteredBox;
